import { Typographies } from '@/theme';
import { Box, Tab, Tabs, styled } from '@mui/material';

export const JTabStyled = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  height: 'auto',
  minHeight: 'auto',
  color: theme.palette.dark.dark_4,
  fontWeight: Typographies.FONT_WEIGHT_H2,
  '&.Mui-selected': {
    color: theme.palette.dark.dark_1,
    '& svg': {
      color: theme.palette.primary.main,
    },
  },
}));
export const TabsStyled = styled(Tabs)(() => ({
  height: 'auto',
  minHeight: 'auto',
}));
export const TabsContainer = styled(Box)(({ theme }) => ({
  borderBottom: 1,
  borderColor: 'divider',
  background: theme.palette.white.main,
}));
